<template>
	<div class="TicketOptionExternalSystemSmeetz" v-if="ticketOption">
		<div class="row">
			<Field :title="$t('text.smeetzSupplierId')">
				<v-text-field variant="outlined" class="mt-3" hide-details style="background-color:#ffffff"
					v-model="ticketOption.fields.external.supplierId" 
					:error-messages="smeetzSupplierIdError"
					@keypress="isNaturalNumber($event)"
				/>
			</Field>
			<Field :title="$t('text.smeetzActivityId')">
				<v-text-field variant="outlined" class="mt-3" hide-details style="background-color:#ffffff"
					v-model="ticketOption.fields.external.activityId" 
					:error-messages="smeetzActivityIdError"
					@keypress="isNaturalNumber($event)"
				/>
			</Field>
		</div>
		<div class="row">
			<Field :title="$t('text.smeetzOptionId')">
				<v-text-field variant="outlined" class="mt-3" hide-details style="background-color:#ffffff"
					v-model="ticketOption.fields.external.optionId" 
					:error-messages="smeetzOptionIdError"
					@keypress="isNaturalNumber($event)"
				/>
			</Field>
			<Field :title="$t('text.smeetzTicketCategoryId')">
				<v-text-field variant="outlined" class="mt-3" hide-details style="background-color:#ffffff"
					v-model="ticketOption.fields.external.ticketCategoryId" 
					:error-messages="smeetzTicketCategoryIdError"
					@keypress="isNaturalNumber($event)"
				/>
			</Field>
		</div>
	</div>
</template>

<script lang="ts">
import Common from '../../mixins/Common.vue'

export default {
	mixins: [ Common ],
	props: {
		ticketOption: Object,
	},
	computed: {
		smeetzSupplierIdError(): string {
			if (!this.userIsOperator && this.spTrustLevel <= 2) return ''
			return !this.ticketOption?.fields.external.supplierId?.length ? this.$t('text.externalSystemRequired') : ''
		},
		smeetzActivityIdError(): string {
			if (!this.userIsOperator && this.spTrustLevel <= 2) return ''
			return !this.ticketOption?.fields.external.activityId?.length ? this.$t('text.externalSystemRequired') : ''
		},
		smeetzOptionIdError(): string {
			if (!this.userIsOperator && this.spTrustLevel <= 2) return ''
			return !this.ticketOption?.fields.external.optionId?.length ? this.$t('text.externalSystemRequired') : ''
		},
		smeetzTicketCategoryIdError(): string {
			if (!this.userIsOperator && this.spTrustLevel <= 2) return ''
			return !this.ticketOption?.fields.external.ticketCategoryId?.length ? this.$t('text.externalSystemRequired') : ''
		},
		valid() {
			return !this.smeetzSupplierIdError
				&& !this.smeetzActivityIdError
				&& !this.smeetzOptionIdError
				&& !this.smeetzTicketCategoryIdError
		},
	},
	methods: {
		async setExternalSystem() {
			if (!this.ticketOption) return
			this.ticketOption.fields.external = {
				supplierId: this.ticketOption.fields.external.supplierId ?? '',
				activityId: this.ticketOption.fields.external.activityId ?? '',
				optionId: this.ticketOption.fields.external.optionId ?? '',
				ticketCategoryId: this.ticketOption.fields.external.ticketCategoryId ?? '',
			}
		},
	},
	beforeMount() {
		// TODO: also check if ticketTypeNumber actually exists, unify with the init in setExternalSystem
		if (!this.ticketOption?.fields.external) {
			this.ticketOption.fields.external = {
				supplierId: '',
				activityId: '',
				optionId: '',
				ticketCategoryId: '',
			}
		}
	},
	async mounted() {
		await this.setExternalSystem()
	},
}
</script>

<style scoped>
.row { display: flex; gap: 10px; width: 100%; }
.row > * { flex: 1 0; }
.row > .Field { border-left: none; padding: 0; }
</style>